import { DateTime } from 'luxon';

import { ISO8601 } from '../types';

export function hourToISOTime(hour: number, timeZone: string) {
    return DateTime.fromObject({ hour }, { zone: timeZone }).toISOTime({ includeOffset: false }) as ISO8601.Time | null;
}
